// O campo de comprimento só existe quando o produto tem configurador,
// regra de quantidade e uma característica de comprimento (PRODUCT_CARACT).
// Produtos como parafuso têm configurador, mas não têm comprimento.
export const hasLengthField = (product: any): boolean =>
  !!product?.product?.configuration?.id &&
  !!product?.quantityRule &&
  !!product?.lengthFieldId
